import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

const FormModal = ({ 
  isOpen, 
  onClose, 
  onSubmit,
  title,
  children,
  submitText = 'حفظ',
  cancelText = 'إلغاء',
  size = 'md',
  isSubmitting = false,
  transitionDuration = 300,
  backdropOpacity = 25,
}) => {
  const sizeClasses = {
    sm: 'sm:max-w-sm',
    md: 'sm:max-w-md',
    lg: 'sm:max-w-lg',
    xl: 'sm:max-w-xl',
    '2xl': 'sm:max-w-2xl',
    '3xl': 'sm:max-w-3xl',
    '4xl': 'sm:max-w-4xl',
    '5xl': 'sm:max-w-5xl',
    '6xl': 'sm:max-w-6xl',
    '7xl': 'sm:max-w-7xl',
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-10 overflow-y-auto" onClose={onClose}>
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter={`ease-out duration-${transitionDuration}`}
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave={`ease-in duration-${transitionDuration}`}
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className={`fixed inset-0 bg-black bg-opacity-${backdropOpacity} backdrop-blur-sm`} />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="inline-block h-screen align-middle" aria-hidden="true">
            &#8203;
          </span>
          
          <Transition.Child
            as={Fragment}
            enter={`ease-out duration-${transitionDuration}`}
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave={`ease-in duration-${transitionDuration}`}
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className={`inline-block w-full ${sizeClasses[size]} overflow-hidden text-right align-middle transition-all transform bg-white dark:bg-gray-800 shadow-xl rounded-lg`}>
              <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900 dark:text-white">
                  {title}
                </Dialog.Title>
              </div>
              <div className="p-6 pt-5">
                <div className="[&>*]:mb-4 last:[&>*]:mb-0 [&_label]:mb-2 [&_label]:block">
                  {children}
                </div>
                <div className="mt-6 flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={onClose}
                    className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-600 rounded hover:bg-gray-200 dark:hover:bg-gray-500 transition-colors duration-200"
                  >
                    {cancelText}
                  </button>
                  <button
                    type="submit"
                    onClick={onSubmit}
                    disabled={isSubmitting}
                    className={`px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded hover:bg-blue-700 transition-colors duration-200 ${
                      isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                  >
                    {isSubmitting ? 'جارٍ الحفظ...' : submitText}
                  </button>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default FormModal;
